import { Action, ActionReducer, createReducer, on } from '@ngrx/store';

import { InstallationsSearchActions } from './installations-search.actions';
import { installationsCollectionLimit } from './installations-search.model';
import { InstallationsSearchState } from './installations-search.state';

export const initInstallationsSearchState: InstallationsSearchState = {
  installations: [],
  _links: [],
  loading: false,
  loaded: false,
  error: null,
  searchParams: {
    gatewaySerial: '',
    boilerSerial: '',
    limit: installationsCollectionLimit,
    cursor: undefined,
  },
};

export const installationsSearchReducer: ActionReducer<
  InstallationsSearchState,
  Action
> = createReducer(
  initInstallationsSearchState,

  on(
    InstallationsSearchActions.listInstallationsSearchResult,
    (state, { gatewaySerial, boilerSerial, limit, cursor }): InstallationsSearchState => ({
      ...state,
      loading: true,
      loaded: false,
      searchParams: {
        gatewaySerial,
        boilerSerial,
        limit,
        cursor,
      },
    })
  ),

  on(
    InstallationsSearchActions.listInstallationsSearchResultSuccess,
    (state, { payload }): InstallationsSearchState => ({
      ...state,
      installations: payload?.data,
      searchParams: {
        ...state.searchParams,
        cursor: payload.cursor?.next,
      },
      loading: false,
      loaded: true,
    })
  ),

  on(
    InstallationsSearchActions.listInstallationsSearchResultError,
    (state): InstallationsSearchState => ({
      ...state,
      loading: false,
      loaded: false,
    })
  ),

  on(
    InstallationsSearchActions.listInstallationsSearchFetchMore,
    (state): InstallationsSearchState => ({
      ...state,
      loading: true,
      loaded: false,
    })
  ),

  on(
    InstallationsSearchActions.listInstallationsSearchFetchMoreSuccess,
    (state, { payload }): InstallationsSearchState => ({
      ...state,
      installations: payload.data
        ? [].concat(payload.data, state.installations)
        : state.installations,
      loading: false,
      loaded: true,
    })
  ),

  on(
    InstallationsSearchActions.listInstallationsSearchFetchMoreError,
    (state): InstallationsSearchState => ({
      ...state,
      loading: false,
      loaded: false,
    })
  )
);
